import React from 'react'

import withModal from './with_modal'

import noImage from '../../assets/png/placeholders/320.png'
import transparentImage from '../../assets/png/transparent.png'
import modalStyles from './modal.module.css'
import styles from './imageShow.module.css'
import { useTranslation } from 'react-i18next'
const download = link => {
  $.ajax({
    url: link,
    headers: {
      Authorization: `Client-ID ${process.env.UNSPLASH_ACCESS_KEY}`
    }
  }).then(res => {
    const reslink = document.createElement('a')
    reslink.href = res.url
    reslink.target = '_blank'
    document.body.appendChild(reslink)
    reslink.click()
    document.body.removeChild(reslink)
  })
}

// eslint-disable-next-line arrow-body-style
const ImageShow = ({ image, user, external }) => {
  const { t } = useTranslation()
  if (!image) return null
  return (
    <div className={modalStyles.modal}>
      <div className={styles.content}>
        <div className={styles.preview} style={{ backgroundImage: `url(${transparentImage})` }}>
          <img src={image.full || image.url} alt="" className={styles.image} />
        </div>
        <div className={styles.info}>
          <h1 className={styles.title}>{image.title}</h1>
          <div className={styles.profile}>
            <div className={styles.profileImg} style={{ backgroundImage: `url(${image.creator_thumb || noImage})` }} />
            {external ? (
              <p>
                {t('photoby')}{' '}
                <a className={styles.name} href={`${image.creator_link}?utm_source=Gwaphics&utm_medium=referral`}>
                  {image.creator}
                </a>
                {' on '}
                <a className={styles.name} href="https://unsplash.com/?utm_source=Gwaphics&utm_medium=referral">
                  {t('unsplash')}
                </a>
              </p>
            ) : (
              <p>
                By <span className={styles.name}>{user.username}</span>
              </p>
            )}
          </div>
          {external ? (
            <button type="button" className="btn-blue" onClick={() => download(image.download)}>
              {t('downloads')}
            </button>
          ) : (
            <a href={image.url} download className={styles.stretch}>
              <button type="button" className="btn-blue">
                Downloads
              </button>
            </a>
          )}
        </div>
      </div>
    </div>
  )
}

export default withModal(ImageShow)
